import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBlock from "../../../components/StatisticsAnalytics/Reports/commonComponents/SearchBlock/SearchBlock";
import DocumentPreview from "../../../components/StatisticsAnalytics/Reports/commonComponents/DocumentPreview/DocumentPreview";
import { fieldsForSearch, getOptionsForField, setOptionsForField } from "./settingsForWeeklyReport";
import { ProgressBar } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { API_GET_WEEKLY_REPORT } from "../../../constants/constants";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import styles from "./weeklyReport.module.css";
function WeeklyReport() {
  const isLoading = useSelector((state) => state.dictionaryReducer.isLoading);
  const [DocsFile, setDocsFile] = useState("");
  const [ExcelFile, setExcelFile] = useState("");
  const [PDFFile, setPDFFile] = useState("");
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const createAccess = useChapterActionIdMatch(
    sortedMenuNames?.REPORTS?.createAReportOrGraph?.chapterActionId,
  );
  const exportAccess = useChapterActionIdMatch(
    sortedMenuNames?.REPORTS?.exportAReportOrGraph?.chapterActionId,
  );
  if (isLoading) {
    return (
      <div className={"d-flex flex-column align-items-center"}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }
  return (
    <div className={styles["content-container"]}>
      <p
        className={styles["back-block"]}
        onClick={() => navigate("/reports")}>
        <span className={styles["back-icon"]}></span>
        <p className={styles["back-text"]}>{"Вернуться к Отчёты"}</p>
      </p>
      <h2 className={styles["main-text"]}>Еженедельный отчет</h2>
      <SearchBlock
        fields={fieldsForSearch}
        setOptionsForField={setOptionsForField}
        urlForReport={API_GET_WEEKLY_REPORT}
        setDocsFile={setDocsFile}
        setExcelFile={setExcelFile}
        setPDFFile={setPDFFile}
        getOptionsForField={getOptionsForField}
        setLoader={setLoader}
        createAccess={createAccess}
      />
      <DocumentPreview
        pdf={PDFFile}
        excel={ExcelFile}
        exportAccess={exportAccess}
      />
      {loader && (
        <div className={"d-flex flex-column align-items-center"}>
          <ProgressBar
            height="80"
            width="80"
            ariaLabel="progress-bar-loading"
            wrapperStyle={{}}
            wrapperClass="progress-bar-wrapper"
            borderColor="#D2AF8E"
            barColor="#BC8653"
          />
        </div>
      )}
    </div>
  );
}

export default WeeklyReport;
